import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, COMMON_IMAGE, drawRectangle, HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE} from '../../canvas-timeline/canvas_timeline_util';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {CSS_CONSTANTS} from '../../../../css_variables';

const positionUserPilotTag = (personIndex, x, y, width, height, userPilotDocumentId) => {
	if (personIndex === 0) {
		const foregroundCanvas = document.getElementById('foreground-canvas');
		const canvasBounds = foregroundCanvas.getBoundingClientRect();
		const upElement = document.getElementById(userPilotDocumentId);
		if (x >= 0 && y >= 0 && x + width < canvasBounds.width && y + height < canvasBounds.height) {
			upElement.style.left = `${x + canvasBounds.x}px`;
			upElement.style.top = `${y + canvasBounds.y}px`;
			upElement.style.height = `${height}px`;
			upElement.style.width = `${width}px`;
		} else {
			upElement.style.left = '0';
			upElement.style.top = '0';
			upElement.style.height = '0';
			upElement.style.width = '0';
		}
	}
};

class HeatmapItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PEOPLE_SCHEDULING_HEATMAP, data);
	}

	draw(canvasContext) {
		const {data, height} = this;
		const {x, y, width, minutesAllocated, minutesAvailable, groupHeight, eyeOptions, isPast, isInActualMode, isDefaultFreeDay, intl, personIndex} = data;

		const isOverallocated = minutesAllocated > minutesAvailable;
		const isWithinCheckmarkRange = isOverallocated ? minutesAllocated / minutesAvailable - 1 < HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE / 100 : minutesAllocated / minutesAvailable - 1 > -HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE / 100;

		const heatmapOptions = eyeOptions && eyeOptions.find(option => option.name === 'show-heatmap') ? eyeOptions.find(option => option.name === 'show-heatmap').nestedOptions : null;

		const shouldShowNumber =
			// always show numbers in the project timeline because we do not have these options in the eye selector
			heatmapOptions && heatmapOptions.find(option => option.name === 'available-numbers').checked && (heatmapOptions.find(option => option.name === 'empty-days-numbers').checked || minutesAllocated !== 0);

		const shouldShowOverbookedNumber = heatmapOptions && heatmapOptions.find(option => option.name === 'overbooked-numbers').checked;

		const overallocationColor = isPast && isInActualMode ? CSS_CONSTANTS.schedule_heatmap_actual_blue : '#FFEBEB';
		const completionColor = isPast && isInActualMode ? CSS_CONSTANTS.schedule_heatmap_actual_blue : '#EBFBF3';
		if (!minutesAllocated && !minutesAvailable) return; //Don't draw anything on days without working hours and any assignments
		if (eyeOptions && eyeOptions.find(option => option.name === 'show-heatmap') && !eyeOptions.find(option => option.name === 'show-heatmap').checked) return;
		if (isWithinCheckmarkRange) {
			drawRectangle(canvasContext, x, y, width - 1, height, {
				backgroundColor: completionColor,
			});
			canvasContext.drawImage(cacheManager.getCommonImage(COMMON_IMAGE.GREEN_CHECKMARK_V2), x + (width - 14) / 2, y + 18.5);
			positionUserPilotTag(personIndex, x, y, width, height, 'userpilot-heatmap-fully-allocated');
		} else if (isOverallocated) {
			drawRectangle(canvasContext, x, y, width - 1, height, {
				backgroundColor: isOverallocated ? overallocationColor : completionColor,
			});

			if (shouldShowOverbookedNumber) {
				canvasContext.font = '700 13px ' + Util.getFontFamily();
				canvasContext.fillStyle = '#4a5969';
				const heatmapNumber = isPast && isInActualMode ? minutesAllocated : minutesAllocated - minutesAvailable;
				let text = Util.convertMinutesToFullHour(heatmapNumber, intl);
				let textWidth = canvasContext.measureText(text).width;
				canvasContext.fillText(text, x + (width - textWidth) / 2, y + 28.5);
			} else {
				canvasContext.drawImage(cacheManager.getCommonImage(isPast && isInActualMode ? COMMON_IMAGE.GREEN_CHECKMARK_V2 : COMMON_IMAGE.WARNING), x + (width - 2) / 2, y + 18.5);
			}

			positionUserPilotTag(personIndex, x, y, width, height, 'userpilot-heatmap-over-allocated');
		} else {
			// draw a background color that will cover the holiday pattern if there is one
			drawRectangle(canvasContext, x, y, width - 1, height, {
				backgroundColor: '#fff',
			});

			const fillFraction = !minutesAllocated ? 0 : minutesAllocated / minutesAvailable;
			const fillPixels = parseInt(fillFraction * height, 10);
			drawRectangle(canvasContext, x, y + height - fillPixels, width - 1, fillPixels, {
				backgroundColor: completionColor,
				backgroundOpacity: 1,
			});
			canvasContext.font = '700 13px ' + Util.getFontFamily();
			canvasContext.fillStyle = '#4a5969';
			let text = shouldShowNumber ? Util.convertMinutesToFullHour(minutesAvailable - minutesAllocated, intl) : '';
			let textWidth = canvasContext.measureText(text).width;
			canvasContext.fillText(text, x + (width - textWidth) / 2, y + 28.5);
		}
		// If no time available, color group background grey
		if (!minutesAvailable && groupHeight && groupHeight > height + 1) {
			const backgroundColor = '#f8f8f8';
			const backgroundOpacity = 1;
			drawRectangle(canvasContext, x, y + height, width - 1, groupHeight - height, {
				backgroundColor,
				backgroundOpacity,
			});
		}

		if (isDefaultFreeDay) {
			// if day is not a holiday for a person (because he has a custom calendar) add a white background that will cover the diagonal line pattern from the default calendar holiday
			drawRectangle(canvasContext, x, y + height + 1, width - 1, groupHeight - height, {
				backgroundColor: '#fff',
				backgroundOpacity: 1,
			});
		}
	}
}
export default HeatmapItem;
